/**
 * Тур по странице водителей.
 * Знакомит пользователя с управлением водителями.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'drivers-page',
  name: 'help.tours.drivers.name',
  description: 'help.tours.drivers.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Шаг 1: Заголовок и кнопка добавления
    {
      element: '.page-toolbar',
      titleKey: 'help.tours.drivers.toolbar.title',
      descriptionKey: 'help.tours.drivers.toolbar.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 2: Статистика водителей
    {
      element: '.stats-row',
      titleKey: 'help.tours.drivers.stats.title',
      descriptionKey: 'help.tours.drivers.stats.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 3: Поиск
    {
      element: '.search-bar',
      titleKey: 'help.tours.drivers.search.title',
      descriptionKey: 'help.tours.drivers.search.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 4: Сетка карточек водителей
    {
      element: '.drivers-grid',
      titleKey: 'help.tours.drivers.grid.title',
      descriptionKey: 'help.tours.drivers.grid.description',
      side: 'top',
      align: 'center',
    },
    // Шаг 5: Карточка водителя
    {
      element: '.driver-card',
      titleKey: 'help.tours.drivers.card.title',
      descriptionKey: 'help.tours.drivers.card.description',
      side: 'left',
      align: 'center',
    },
    // Шаг 6: Действия с карточкой (кнопка разворачивания)
    {
      element: '.expand-btn',
      titleKey: 'help.tours.drivers.expand.title',
      descriptionKey: 'help.tours.drivers.expand.description',
      side: 'left',
      align: 'center',
    },
  ],
}
